import { useState } from 'react'
import { ReactComponent as PlusIcon2 } from '@/assets/icons/plus-icon-2.svg'
import './AddLabelButton.scoped.sass'

import ModalContainer from '@/components/commons/Modal/Modal'
import { AddLabelModalContainer } from './AddBoxLabelModalContainer/AddBoxLabelModalContainer'

export function AddLabelButton () {
  const [openModal, setOpenModal] = useState(false)
  const openAddLabelModal = () => setOpenModal(true)
  const closeAddLabelModal = () => setOpenModal(false)
  return <div>
    <PlusIcon2 onClick={openAddLabelModal}/>
    <ModalContainer showModal={openModal} modalType={'sm'} modalContent={<AddLabelModalContainer closeAddLabelModal={closeAddLabelModal} />} />
  </div>
}
